<template>
  <div
    class="v-input theme--light"
    style="display: flex; align-items: flex-end; margin-bottom: 1rem;"
  >
    <!-- Always render a checkbox -->
    <v-checkbox
      v-model="model.enabled"
      :label="label"
      color="#0F998E"
      hide-details
      :disabled="disabled"
      class="ma-0 pa-0"
      style="min-height: auto; height: auto;"
    />

    <!-- If it's not a pure checkbox, show the input -->
    <template v-if="!model.isCheckbox">
      <input
        type="number"
        v-model="model.value"
        :disabled="disabled || !model.enabled"
        style="border-bottom: 1px solid gray; max-width: 20%; margin-left: 1rem; text-align: center;"
      />
      <span v-if="suffix">{{ suffix }}</span>
    </template>
  </div>
</template>

<script>
export default {
  name: "GlobalSettingItem",
  props: {
    value: { type: Object, required: true }, // { value, enabled, isCheckbox }
    label: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    suffix: { type: String, default: "" }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val) // Vue 2 v-model compatibility
      }
    }
  }
}
</script>
